import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  Input,
  SimpleChange,
  OnDestroy,
} from "@angular/core";
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { concatMap } from 'rxjs/internal/operators';

// Leaflet
import * as L from 'leaflet';
import "leaflet-routing-machine";
import { of } from 'rxjs';

//Services
import { MapSharedService } from '../../services/map-shared.service';
import { MapMarkerService } from '../../services/map-marker.service';
import { MapDataService } from '../../services/map-data.service';

import { DirectionProvider } from '../map-utils/direction-provider';
import { IWayPoint } from '../../itinenary-list/itinerary';
import { IMapSettings } from 'src/app/dashboard/map-settings/settings';
import { IItineraryRoute } from '../../itinerary-route/itinerary-route';
import { FileDataService } from '../../services/file-data.service';
import { delay } from "rxjs/operators";
import * as moment from "moment"; // Time Calculation
import { SelectionModel } from "@angular/cdk/collections";

@Component({
  selector: "app-map-route",
  template: "<ng-content></ng-content>",
})
export class MapRouteComponent implements OnInit, OnDestroy {
  @Input() map: L.Map;
  @Input() mapSettings: IMapSettings;
  @Input() currentItineraryDetails: IWayPoint[];
  @Output() hideRouteSummaryTemplate = new EventEmitter<boolean>();
  @Output() sendNewWaypointData = new EventEmitter<IWayPoint>();

  // Route related instance
  currentRoutingControl: L.Routing.Control;
  currentRoutingControl1: L.Routing.Control;
  lineControl: L.Routing.Line;
  itnRouteControlList: { id: number, route: L.Routing.Control, polyline: L.Polyline }[] = [];
  coordinatePolyLine: L.Polyline;
  isDrawPolygon: boolean = false;
  compareRouteList2: L.Routing.Control[];
  routePopupContentList: string[] = [];
  routeMarkerList: L.Marker[] = [];

  waypointDistTimeList: { distance: string; time: string }[] = [];
  directionProvider: DirectionProvider;
  selectedRoute: L.Routing.IRouter;

  // Subscription List
  subs: Subscription[] = [];
  enableRouteLine: boolean = true;

  optimizedRouter: L.Routing.IRouter;
  optimizeSub: Subscription;
  totalDistance = 0;
  totalTime = 0;

  firstLatLng: boolean = true;
  routeControlList = [];
  routeLine = [];
  compareRouteControlList: { id: number, route: L.Routing.Control, polyline: L.Polyline }[] = [];
  compareRouteList100: { id: number, compareRoute: any[] }[] = []
  // compareRouteControlList100: { id: number, route: L.Routing.Control }[] = [];
  routeEnable: boolean;
  latLongList: any;
  globalIndex: number = 1;
  distances: any[] = [];
  idValue: any;
  totalDistances: any;
  totalTimes: any;
  event: any;
  currentDistance: any[] = []
  selection = new SelectionModel<IWayPoint>(true);

  constructor(
    private sharedService: MapSharedService,
    private mapService: MapDataService,
    private mapMarker: MapMarkerService,
    private fileService: FileDataService,
    private snackBar: MatSnackBar,
  ) {
    this.directionProvider = new DirectionProvider();

  }

  ngOnInit() {
    this.renderItineraryDetailsOnMap();
    this.clearMapDirections();
    this.displaySelectedItineraryItem();
    this.compareItineraryRoutes();
    this.removeCompareItnRoutes();
    this.optimiseItinerary();
    this.focusEntireItinerary();
    this.displayUTurn();
    this.addDelayPoint();
    // WAYPOINT SELECTION IN LIST BASED ON MAP
    this.subs.push(this.fileService.selectrdMarker$.subscribe(marker => {
      if (marker) {
        this.idValue = marker.id;
        this.particularWaypointDistance(this.idValue);
      }

    }));

  }

  ngOnChanges(changes: SimpleChange) {
    for (const input in changes) {
      if (changes.hasOwnProperty(input)) {
        switch (input) {
          case 'mapSettings':
            this.onDirectionProviderChange(changes[input].currentValue);
            break;
          case 'currentItineraryDetails':

            this.renderRoutesBasedOnMapSettings();
            break;
          default: break;
        }
      }
    }
  }

  particularWaypointDistance(id: any) {
    let chunks = id;
    let totaldis = [];
    let totalTimeCalculate = [];
    let currentDistance = [];
   // console.log("distances", this.distances)
    this.fileService.distanceWaypoint = this.distances;
    for (let i = 0, j = this.distances.length; i < j; i = chunks) {
      currentDistance = this.distances.slice(i, i + chunks);
      break;
    }
    for (let firstdis of currentDistance) {
      if (firstdis.distance != "0km") {
        let convertDistanceFloatValue = parseFloat(firstdis.distance);
        totalTimeCalculate.push(firstdis.time)
        const sum = totalTimeCalculate.reduce((acc, time) => acc.add(moment.duration(time)), moment.duration());
        let timeValue = [Math.floor(sum.asHours()), sum.minutes()].join(':')

        let convertTimeFloatValue = firstdis.time.replace(":", ".");
        let time = parseFloat(convertTimeFloatValue);
        totaldis.push(convertDistanceFloatValue);
        totalTimeCalculate.push(time);
        let distanceValue = totaldis.reduce((a, b) => a + b, 0);
        this.totalDistances = distanceValue.toFixed(2);
        this.totalTimes = timeValue.toString() + "h";
        //  this.totalTimes=this.totalTimes.replace(".",":"); // TOTAL TIME VALUE
        this.totalDistances = this.totalDistances.toString() + "km";    //TOTAL DISTANCE VALUE
      }
    }
    this.bindMethod(this.idValue - 1, this.totalDistances, this.totalTimes);
  }

  renderRoutesBasedOnMapSettings() {
    const enableLineDirections = !!(this.mapSettings && this.mapSettings.recalculateItinerary);
    this.intiateRouteRendering(enableLineDirections);
  }

  clearLineRoute() {
    if (this.lineControl) {
      this.routeLine.forEach((ele: L.Routing.Line) => {
        this.map.removeLayer(ele);
      })
      this.routeLine = [];
      // this.map.removeLayer(this.lineControl);
    }
  }
  createPolyline(waypointList: IWayPoint[]): L.Polyline {
    try {
      const latLongList = this.sharedService.getLatLongList(waypointList);
      if (latLongList.length) {
        const polyline = L.polyline(latLongList, { color: "#ff7800", weight: 5, })
          .addTo(this.map);
        const bounds = L.latLngBounds(latLongList);
        this.map.fitBounds(bounds);
        return polyline;
      }
    }
    catch (ex) { }
  }

  intiateRouteRendering(enableRouteLine: boolean) {
    // Step 1: This helps to decides whether to show line routes or not(Automatic recalculate itinerary)
    this.enableRouteLine = enableRouteLine;
    // Step 2: clear existing line route to avoid overlapping lines after route lines are recalculated
    this.clearLineRoute();
    // Step 3 : Clear polyline
    if (this.coordinatePolyLine) this.map.removeLayer(this.coordinatePolyLine);
    // Step 4: calculate route for given waypoints
    if (this.currentRoutingControl) {
      this.routeControlList.forEach((ele: L.Routing.Control) => {
        this.map.removeControl(ele);
      })
      this.routeControlList = [];
      // this.map.removeControl(this.currentRoutingControl)
    }
    this.fileService.isDrawPolygon
      ? this.coordinatePolyLine = this.createPolyline(this.currentItineraryDetails)
      : this.addRoutingControl();
  }
  /**
   * Render maps on click of GET DIRECTION icon<ITINERARY TABLE>
   */
  renderItineraryDetailsOnMap() {
    // Watch for changes, if any Itinerary details to be rendered on MAP
    this.subs.push(
      this.sharedService.isGetMapDirections$.subscribe((isRender) => {
        if (isRender) {
          this.intiateRouteRendering(true);
        }
      })
    );
  }

  focusEntireItinerary() {
    this.subs.push(
      this.sharedService.getEntireItinerary.subscribe((isShow) => {
        if (isShow) {
          // console.log(isShow);
          const latLongList = this.sharedService.getLatLongList(this.currentItineraryDetails);
          const bounds = L.latLngBounds(latLongList);
          this.map.fitBounds(bounds);
        }

      })
    );

  }

  addDelayPoint() {
    this.subs.push(this.sharedService.getUturnItineraryDelay.pipe(
      concatMap(item => of(item).pipe(delay(500)))
    ).subscribe((temparray: L.LatLng[]) => {
      this.currentRoutingControl1 = L.Routing.control({
        waypoints: temparray,
        routeLine: (route) => this.generateRouteLineControl(route),
        fitSelectedRoutes: false,
        plan: L.Routing.plan(temparray, {
          createMarker: () => null,
          draggableWaypoints: false,
          routeWhileDragging: false
        }),
        router: this.directionProvider.tomtomRoute({
          selectedDirectionProvider: `Tom Tom Maps`,
          selectedDrivingDirection: `fastest`,
          selectedVehicle: `car`,
          avoidHighways: true,
          avoidTolls: true
        }, true)
      });
      this.fileService.isDisableUTurn = true;
      this.currentRoutingControl1.addTo(this.map);

      this.currentRoutingControl1.on("routesfound", (event) => {
        this.onRoutesFound(event);
      });
      this.currentRoutingControl1.on("routingerror", (event) => {
        this.snackBar.open(event.error.message, 'close', {
          duration: 12000,
          verticalPosition: 'top'
        });
      });
    }));

  }
  displayUTurn() {
    this.subs.push(
      this.sharedService.getUturnItinerary.subscribe((isUturn) => {
        if (isUturn) {
          this.totalTime = 0;
          this.totalDistance = 0;
          this.clearLineRoute();
          const latLongList = this.sharedService.getLatLongList(this.currentItineraryDetails);


          for (let i = 0, j = latLongList.length; i < j; i += 2) {
            const temparray = latLongList.slice(i, i + 2);
            i--;
            this.sharedService.enableUTurnItineraryDelay(temparray);
          }
        }

      })
    );

  }

  /**
   * Clear line-direction on Maps with click of CLEAR DIRECTION icon<ITINERARY TABLE>
   */
  clearMapDirections() {
    this.subs.push(
      this.sharedService.isClearMapDirections$.subscribe((isClearMap) => {
        if (isClearMap) {
          this.clearLineRoute();
        }
      })
    );
  }
  /**
   * Centers and highlights the selected Itinerary item in the Table
   */
  displaySelectedItineraryItem() {
    this.subs.push(
      this.sharedService.getSelectedItineraryItem.subscribe(
        (selectedItinerary: any) => {
          // Centering the item
          this.map.panTo(
            L.latLng(selectedItinerary.latitude, selectedItinerary.longitude)
          );
          if (this.firstLatLng) {
            //open the marker popup
            const selectedMarker = this.routeMarkerList.filter(marker => {
              return marker.getLatLng().lat === parseFloat(selectedItinerary.latitude) &&
                marker.getLatLng().lng === parseFloat(selectedItinerary.longitude)
            })
            if (selectedMarker.length) {
              selectedMarker[0].openPopup();
            }
          } else {
            this.firstLatLng = true;
          }

        })
    );
  }
  /**
   * This function is called whenever `MAP-SETTINGS`
   * are changed and current direction provider
   * from settings are considered to form ROUTE
   * @param mapSettings
   */
  onDirectionProviderChange(mapSettings: IMapSettings) {
    if (mapSettings) {
      const {
        selectedDirectionProvider,
        selectedDrivingDirection,
        selectedVehicle,
        avoidHighways,
        avoidTolls
      } = mapSettings;
      this.selectedRoute = this.directionProvider.getDirectionProvider({
        selectedDirectionProvider,
        selectedDrivingDirection,
        selectedVehicle,
        avoidHighways,
        avoidTolls
      })
      this.mapSettings = mapSettings;
      this.intiateRouteRendering(true);
    }
  }
  optimiseItinerary() {
    this.subs.push(
      this.sharedService.isOptimiseItinerary$.subscribe(
        (isOptimise: boolean) => {
          if (isOptimise) {
            const { router, optimizeWaypoint } = this.directionProvider.bingMapRoute({
              selectedDirectionProvider: `Microsoft Bing Maps`,
              selectedDrivingDirection: ``,
              selectedVehicle: `Driving`,
              avoidHighways: true,
              avoidTolls: true
            },
              true
            );
            this.optimizedRouter = router;
            this.intiateRouteRendering(true);
            // subscription is from DPBing()
            this.optimizeSub = optimizeWaypoint.subscribe(res => {
              this.rearrangeItinerary(res);
              this.cleanupOptimiseItineraryResource();
            },
              _ => {
                this.cleanupOptimiseItineraryResource();
              }
            );
          } else {
            this.optimizedRouter = null;
          }
        }
      )
    );
  }
  /**
   * Rearrange the `currentItineraryDetails`
   * @param reorderList - Reordered optimized waypoints from Bing Maps
   */
  rearrangeItinerary(reorderList: any) {
    // Reorder logic
    const clone = [...this.currentItineraryDetails];
    clone.forEach((itineray: IWayPoint, index: number) => {
      const newIndex = Number(reorderList[index].split('.')[1]);
      clone[index] = this.currentItineraryDetails[newIndex];
    });
    this.fileService.changeItinenaryData(clone, true);
  }
  cleanupOptimiseItineraryResource() {
    setTimeout(() => {
      this.optimizeSub.unsubscribe();
      this.sharedService.initiateOptimiseItinerary(false);
    }, 100);
  }

  /**
   * Route control for selected `ITINERARY ROUTE` is added
   * and compared with exsiting `ITINERARY`
   */
  combineArray(array1, array2) {
    return [].concat(array1, array2);
  }
  compareItineraryRoutes() {
    this.subs.push(
      this.sharedService.isItineraryRouteRender$.subscribe(
        (route: IItineraryRoute) => {
          if (!route.isPolygon) {
            // Create new Routing instance and add it to map
            const compareRouteList: any[] = [];
            const latLongList = this.sharedService.getLatLongList(route.waypoints);
            const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
            if (latLongList.length > 99) {
              this.compareRouteControlList = []
              for (let i = 0, j = latLongList.length; i < j; i += 100) {
                const temparray = latLongList.slice(i, i + 100);
                i--;
                const compareRouteControl = L.Routing.control({
                  waypoints: temparray,
                  lineOptions: {
                    styles: [{ color: randomColor, weight: 1.5 }],
                    missingRouteStyles: [{ opacity: 0 }],
                    addWaypoints: false
                  },
                  router: this.selectedRoute,
                  plan: L.Routing.plan(temparray, {
                    createMarker: () => null,
                    draggableWaypoints: true,
                    routeWhileDragging: true
                  }),
                })
                compareRouteList.push(compareRouteControl)
              }

              compareRouteList.forEach((compreRoutes: L.Routing.Control) => {
                // this.itnRouteControlList=[];
                const polyline = null;
                this.compareRouteControlList.push({
                  id: route.id,
                  route: compreRoutes,
                  polyline
                });
                compreRoutes.addTo(this.map);
                //this.compareRouteList2.push(compreRoutes);
                // To hide the Distance Calculation Template on top-right
                compreRoutes.hide();
                this.hideRouteSummaryTemplate.emit(true);
                // route.id++;
                //  this.addItineraryRouteControl(route, compreRoutes, null);
                //this.routeEnable = true;
              })
              this.compareRouteList100.push({
                id: route.id,
                compareRoute: this.compareRouteControlList,
              })
              this.compareRouteList2 = compareRouteList;
              this.routeEnable = true;
            } else {
              this.routeEnable = false;
              const compareRouteControl = L.Routing.control({
                waypoints: latLongList,
                lineOptions: {
                  styles: [{ color: randomColor, weight: 1.5 }],
                  missingRouteStyles: [{ opacity: 0 }],
                  addWaypoints: false
                },
                router: this.selectedRoute,
                plan: L.Routing.plan(latLongList, {
                  createMarker: () => null,
                  draggableWaypoints: true,
                  routeWhileDragging: true
                }),
              })
              this.addItineraryRouteControl(route, compareRouteControl, null);
            }
          } else {
            if (route.multiRoute) {
              route.waypoints.forEach(element => {
                const polyline = this.createPolyline(element as any);
                this.itnRouteControlList.push({
                  id: route.id,
                  route: null,
                  polyline
                });
              });
            } else {
              this.routeEnable = false;
              const polyline = this.createPolyline(route.waypoints);
              this.addItineraryRouteControl(route, null, polyline);
            }
          }

        })
    )
  }
  addItineraryRouteControl(route: IItineraryRoute, compareRouteControl: L.Routing.Control | null, polyline: L.Polyline | null) {
    // Render the RouteControl and store it in the array
    // ONLY-IF its not in the list
    const routeControl = this.getItnRouteControl(route);
    if (!routeControl) {
      this.itnRouteControlList.push({
        id: route.id,
        route: compareRouteControl,
        polyline
      });
      if (compareRouteControl) {
        compareRouteControl.addTo(this.map);
        // To hide the Distance Calculation Template on top-right
        compareRouteControl.hide();
        this.hideRouteSummaryTemplate.emit(true);
      }
    }
  }
  removeCompareItnRoutes() {
    try {
      this.subs.push(
        this.sharedService.getRemoveItineraryRouteControl$.subscribe(
          (removeRoute: IItineraryRoute) => {
            const latLongList = this.sharedService.getLatLongList(removeRoute.waypoints);
            if (removeRoute.multiRoute) {
              for (var i = 0; i < removeRoute.waypoints.length; i++) {
                const routeControl = this.getItnRouteControl(removeRoute);
                if (routeControl) {
                  if (routeControl.route) {
                    // removes lines from map
                    routeControl.route.spliceWaypoints(0, removeRoute.waypoints.length);
                  } else {
                    this.map.removeLayer(routeControl.polyline);
                  }
                  // removes routecontrol from list
                  const index = this.itnRouteControlList.indexOf(routeControl);
                  this.itnRouteControlList.splice(index, 1);
                }
              }
            }
            else {
              if (this.routeEnable == true && latLongList.length > 99 && removeRoute.isPolygon == false) {
                if (this.compareRouteList100.length > 0) {
                  this.compareRouteList100.forEach((element) => {
                    element.compareRoute.forEach(elem => {
                      //const remp = this.getCompareItnRouteControl(elem as any)  
                      const remp = elem;
                      if (remp) {
                        if (removeRoute.id === remp.id) {
                          if (remp.route) {
                            remp.route.remove();
                          }
                        }
                      }
                    })
                  });
                }
              }
              else {
                const routeControl = this.getItnRouteControl(removeRoute);
                if (routeControl) {
                  if (routeControl.route) {
                    // removes lines from map
                    routeControl.route.spliceWaypoints(0, removeRoute.waypoints.length);
                  } else {
                    this.map.removeLayer(routeControl.polyline);
                  }
                  // removes routecontrol from list
                  const index = this.itnRouteControlList.indexOf(routeControl);
                  this.itnRouteControlList.splice(index, 1);
                }

              }

            }

          }
        )
      )
    }
    catch (ex) {

    }

  }

  /* Helper function to check if given route
   * is already present in the list */
  getItnRouteControl(route: IItineraryRoute) {
    return this.itnRouteControlList.find(control => {
      return control.id === route.id
    })
  }
  getCompareItnRouteControl(route: IItineraryRoute) {
    return this.compareRouteControlList.find(control => {
      return control.id === route.id
    })
  }
  /**
   * Handles dynamically adding new waypoint in between two waypoints
   * `Directly add to stage` option in Map Settings
   * @param latLng - latitude and longitude of clicked waypoint
   * @param afterIndex - closest index of clicked Waypoint
   */
  addNewWaypoint(latLng: L.LatLng, afterIndex: number) {
    const radius = this.mapSettings.waypointsOnRoad ? 100 : 0;
    const { lat, lng } = latLng;
    this.mapService.reverseGeocodeCoordinates(lat, lng).subscribe(
      (result: any) => {
        if (result.responseStatus === 'Success') {
          const waypoint = result.responseData;
          waypoint.id = afterIndex + 1;
          waypoint.sequenceId = afterIndex + 1;
          this.sendNewWaypointData.emit(waypoint);
        }
      }
    );
  }

  generateRoutePlan(latLongList: L.LatLng[]) {
    let popUpContent: string = '';
    let waypointLabel: string = '';
    this.routeMarkerList = [];
    this.routePopupContentList = [];
    // Add respective marker for everypoint waypoint displayed in ITINERARY TABLE
    // NOTE: createMarker() is executed for every waypoint in list
    const routePlan = L.Routing.plan(
      latLongList,
      {
        createMarker: (index: number, waypoint: any, numberOfWaypoints: number) => {
          const indexNumber = this.currentItineraryDetails.findIndex(item =>
            parseFloat(item.latitude) === waypoint.latLng.lat && parseFloat(item.longitude) === waypoint.latLng.lng);
          if (indexNumber >= 0) {
            const {
              latitude,
              longitude,
              itineraryName,
            } = this.currentItineraryDetails[indexNumber];
            popUpContent = this.mapMarker.generatePopupContent(
              latitude,
              longitude,
              itineraryName,
              false,
              indexNumber + 1
            );
            waypointLabel = itineraryName;
          }
          const markerIndex = this.mapSettings.waypointNumber ? indexNumber + 1 : 0;
          const routeMarker = this.mapMarker.generateMarker(
            waypoint.latLng.lat,
            waypoint.latLng.lng,
            `${waypointLabel}`,
            popUpContent,
            markerIndex,
            numberOfWaypoints = this.currentItineraryDetails.length
          );

          this.routePopupContentList.push(popUpContent);
          this.fileService.routePopup = this.routePopupContentList;
          this.routeMarkerList.push(routeMarker);
          return routeMarker;
        },
        draggableWaypoints: false,
        routeWhileDragging: false
      });
    return routePlan;
  }

  /**
   * Custom styling for the route line displayed.
   * Also to get instance of L.Routing.line which can later be used for 'clearDirections'
   * @param route
   */
  generateRouteLineControl(route: any) {
    const weight = this.enableRouteLine ? 2 : 0;
    this.lineControl = L.Routing.line(route, {
      styles: [{ color: "blue", weight: 3, opacity: 0.6 }],
      addWaypoints: this.mapSettings.addRouteDirectly,
      missingRouteStyles: [{ opacity: 0, }]
    });
    this.lineControl.on('linetouched', (event: any) => {
      this.addNewWaypoint(event.latlng, event.afterIndex);
    })
    this.routeLine.push(this.lineControl);
    return this.lineControl;
  }

  /**
   * Function responsible for Routing related functionalities,
   * as part of <GET DIRECTIONS> in ITINERARY TABLE
   */
  private addRoutingControl() {
    // Remove all existing markers
    // for (const marker of this.routeMarkerList) {
    //   this.map.removeLayer(marker);
    // }
    this.clearLineRoute();
    this.totalDistance = 0;
    this.totalTime = 0;
    this.distances = [];
    // Get the Latitude and Longitude from ITINERARY DETAILS displayed in table
    const latLongList = this.sharedService.getLatLongList(this.currentItineraryDetails);
    const chunk = (this.mapSettings && this.mapSettings.selectedDirectionProvider === 'Microsoft Bing Maps') ? 25 : 150;
    //const routeControlList = [];

    const valueForSelectedRoute = (this.fileService.isFitSelectRoute) ? true : false;
    for (let i = 0, j = latLongList.length; i < j; i += chunk) {
      const temparray = latLongList.slice(i, i + chunk);
      i--;
      this.currentRoutingControl = L.Routing.control({
        waypoints: temparray,
        routeLine: (route) => this.generateRouteLineControl(route),
        fitSelectedRoutes: valueForSelectedRoute,
        showAlternatives: true,
        plan: this.generateRoutePlan(temparray),
        router: this.optimizedRouter ? this.optimizedRouter : this.selectedRoute
      });
      this.routeControlList.push(this.currentRoutingControl);
    }

    this.routeControlList.forEach((routeControl: L.Routing.Control) => {
      routeControl.addTo(this.map);
      // To hide the Distance Calculation Template on top-right
      routeControl.hide();
      this.hideRouteSummaryTemplate.emit(true);
      routeControl.on("routesfound", (event) => {
        this.onRoutesFound(event);
      });
      routeControl.on("routingerror", (event) => {
        this.snackBar.open(event.error.message, 'close', {
          duration: 12000,
          verticalPosition: 'top'
        });
        this.firstLatLng = false;
        this.sharedService.showSelectedItineraryItem({
          latitude: event.sourceTarget.options.waypoints[0].lat,
          longitude: event.sourceTarget.options.waypoints[0].lng
        })
        this.displaySelectedItineraryItem();
      });
      this.fileService.isFitSelectRoute = false;
    });

  }
  onRoutesFound(event: any) {
    // Total Distance and Time between first and last waypoint
    this.totalDistance += event.routes[0].summary.totalDistance;
    this.totalTime += event.routes[0].summary.totalTime;
    const distUnit = this.mapSettings && this.mapSettings.milesDistance ? "miles" : "km";
    const totalDistanceTime = this.distTimeConversion(
      this.totalDistance,
      this.totalTime,
      distUnit
    );
    this.sharedService.changeItineraryDistanceTime(totalDistanceTime);

    // NOTE: As the `instructions` is available only in `routesfound` event
    // Distance time calculation is appended in this eventlistener
    this.waypointDistTimeList = this.computeConsecutiveWaypointDistTime(
      event.routes[0].instructions,
      distUnit
    );

    let tempArray: any[] = [];
    this.waypointDistTimeList.forEach((waypoints) => {
      tempArray.push(waypoints)
    });

    tempArray.reverse();
    tempArray.forEach((waypoints) => {
      this.distances.push(waypoints)
    });

    if (this.distances.length == this.routeMarkerList.length) {
      this.distances.reverse();
      this.fileService.distanceWaypoint = this.distances;
      this.fileService.routeMarker = this.routeMarkerList;
      this.distances.forEach((waypoint, index) => {
        if (index !== 0 && this.routeMarkerList[index]) {
          if (this.routeMarkerList.length == 2) {
            // console.log("distance",this.distances);
            this.particularWaypointDistance(index)
            this.routeMarkerList[index].bindPopup(`${this.routePopupContentList[index]}
          <strong>Distance :</strong> ${waypoint.distance}(${waypoint.time}h) `);
          }
          else {
            this.routeMarkerList[index].bindPopup(`${this.routePopupContentList[index]}
          <strong>Distance :</strong> ${waypoint.distance}(${waypoint.time}h)`);
          }
        }

      });

    }
    // this.bindMethod()
  }
  bindMethod(ids?: any, distance?: any, totalTime?: any) {
    this.distances.forEach((waypoint, index) => {
      if (index !== 0 && this.routeMarkerList[index]) {
        if (this.routeMarkerList.length == 2) {
          this.routeMarkerList[index].bindPopup(`${this.routePopupContentList[index]}
        <strong>Distance :</strong> ${waypoint.distance}(${waypoint.time}h)/${distance}(${totalTime}) `);
        }
        else {
          this.routeMarkerList[index].bindPopup(`${this.routePopupContentList[index]}
        <strong>Distance :</strong> ${waypoint.distance}(${waypoint.time}h)/${distance}(${totalTime}) `);
        }

        if (ids && distance) {
          if (ids >= 1800) {
            let id = ids
            if (this.routeMarkerList.length == 2) {
              this.routeMarkerList[index].bindPopup(`${this.routePopupContentList[id]}
          <strong>Distance :</strong> ${waypoint.distance}(${waypoint.time}h)/${distance}(${totalTime}) `);
            }
            else {
              this.routeMarkerList[index].bindPopup(`${this.routePopupContentList[id]}
          <strong>Distance :</strong> ${waypoint.distance}(${waypoint.time}h)/${distance}(${totalTime}) `);
            }
          }

        }
      }

    });
  }

  computeConsecutiveWaypointDistTime(instructions: any[], distUnit: string) {
    const distTimeList = [{ distance: "0km", time: "00" }];
    instructions.forEach((item) => {
      const formatData = this.distTimeConversion(
        item.distance,
        item.time,
        distUnit
      );
      distTimeList.push(formatData);
    });
    return distTimeList;
  }

  distTimeConversion(distance: number, time: number, distUnit: string) {
    const computedDistance =
      distUnit === "km"
        ? `${(distance / 1000).toFixed(2)}km`
        : `${(distance / 1609).toFixed(2)}mi`;
    const hr = Math.floor(time / 3600) >= 10
      ? `${Math.floor(time / 3600)}`
      : `0${Math.floor(time / 3600)}`;
    const min = Math.round((time % 3600) / 60) >= 10
      ? `${Math.round((time % 3600) / 60)}`
      : `0${Math.round((time % 3600) / 60)}`
    return {
      distance: computedDistance,
      time: `${hr}:${min}`,
    };
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
    this.totalDistances = "";

  }
}
